import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetMyMembershipQuery } from '@api/endpoints/onboardingApi';

/**
 * Wraps the home page to redirect users with a provider mapping
 * to their provider scorecard. If the user has no provider mapping
 * or the query is still loading, the children (home page) render normally.
 */
export default function ProviderHomeRedirect({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useGetMyMembershipQuery();
  const navigate = useNavigate();

  const providerMapping = data?.membership?.providerMapping;

  useEffect(() => {
    if (!isLoading && providerMapping) {
      navigate(
        `/analytics/provider-scorecard?view=completed&provider=${encodeURIComponent(providerMapping)}`,
        { replace: true },
      );
    }
  }, [isLoading, providerMapping, navigate]);

  // Show children (home page) while loading or if no provider mapping
  return <>{children}</>;
}
